import styled from "@emotion/styled";

export const QuestionPlaceholder = styled.img`
  width: 100%;
`;

export default QuestionPlaceholder;
